import { Injectable } from '@angular/core';
import { BehaviorSubject, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  private _searchSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public search$ = this._searchSubject.asObservable().pipe(shareReplay());

  public setSearchTerm(search: string) {
    this._searchSubject.next(search)
  }

  public clearSearchTerm() {
    this._searchSubject.next('')
  }
}
